import get from 'lodash/get';

type TaskModel = {
  get: (key: string) => any;
};

export type Application =
  | {
      get: (key: string) => any;
      tasksCollection: {
        find: (model: any) => TaskModel;
        get: (key: string) => TaskModel;
        models: TaskModel[];
      };
    }
  | null
  | undefined;

export const PROJECT_TAGS = 'projectTags';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const SHOWING_MODAL = 'showingModal';
export const SIDEBAR_WIDTH = '79px';

export const getApplication = () =>
  get(window, 'bugherd.application') as Application;

export const getLangKey = () => 'en' as const;

export const getApplicationDomainUrl = () => {
  const application = getApplication();
  return application ? application.get('bugherdUrl') : null;
};

export const getScreenshotServerUrl = () => {
  const application = getApplication();
  return application ? application.get('screenshotServerUrl') : null;
};

export const getBugherd = () => get(window, 'bugherd');

export const getBugsnag = () => get(window, 'bugsnagClient');
